import { Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ClearSearchButtonProps {
  onClear: () => void;
  className?: string;
}

export function ClearSearchButton({ onClear, className }: ClearSearchButtonProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClear}
      className={className}
      title="Limpiar búsqueda guardada"
    >
      <Trash2 className="h-4 w-4" />
      Limpiar
    </Button>
  );
}
